/**
 * PonyPop Theme JavaScript
 * Handles video modal, animations, and interactive elements
 */

(function() {
  'use strict';

  // ===========================================
  // Video Modal
  // ===========================================
  
  class VideoModal {
    constructor() {
      this.modal = document.getElementById('video-modal');
      this.openBtns = document.querySelectorAll('[data-video-modal]');
      this.closeBtn = document.querySelector('.modal-close');
      this.videoContainer = document.querySelector('.video-container');
      
      if (this.modal) {
        this.init();
      }
    }
    
    init() {
      // Open modal buttons
      this.openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      });
      
      // Close button
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }
      
      // Close on overlay click
      this.modal.addEventListener('click', (e) => {
        if (e.target === this.modal) {
          this.close();
        }
      });
      
      // Close on escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.modal.classList.contains('active')) {
          this.close();
        }
      });
    }
    
    open() {
      this.modal.classList.add('active');
      document.body.style.overflow = 'hidden';
      
      // Focus trap
      this.closeBtn?.focus();
    }
    
    close() {
      this.modal.classList.remove('active');
      document.body.style.overflow = '';
      
      // Stop video if playing
      const iframe = this.videoContainer?.querySelector('iframe');
      const video = this.videoContainer?.querySelector('video');
      
      if (iframe) {
        const src = iframe.src;
        iframe.src = '';
        setTimeout(() => { iframe.src = src; }, 100);
      }
      
      if (video) {
        video.pause();
      }
    }
  }

  // ===========================================
  // Scroll Reveal Animations
  // ===========================================
  
  class ScrollReveal {
    constructor() {
      this.elements = document.querySelectorAll('.reveal');
      
      if (this.elements.length) {
        this.init();
      }
    }
    
    init() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      }, {
        threshold: 0.1,
        rootMargin: '0px 0px -50px 0px'
      });
      
      this.elements.forEach(el => observer.observe(el));
    }
  }

  // ===========================================
  // Header Scroll Behavior
  // ===========================================
  
  class StickyHeader {
    constructor() {
      this.header = document.querySelector('.site-header');
      this.lastScroll = 0;
      
      if (this.header) {
        this.init();
      }
    }
    
    init() {
      window.addEventListener('scroll', () => {
        const currentScroll = window.pageYOffset;
        
        if (currentScroll > 100) {
          this.header.classList.add('scrolled');
        } else {
          this.header.classList.remove('scrolled');
        }
        
        this.lastScroll = currentScroll;
      });
    }
  }

  // ===========================================
  // Mobile Menu
  // ===========================================
  
 
  document.addEventListener('DOMContentLoaded', () => {
    const toggle = document.querySelector('.mobile-menu-toggle');
    const nav = document.querySelector('.main-nav');

    if (!toggle || !nav) return;

toggle.addEventListener('click', () => {
  const isOpen = nav.classList.contains('mobile-open');

  toggle.setAttribute('aria-expanded', String(!isOpen));
  toggle.classList.toggle('active', !isOpen);
  nav.classList.toggle('mobile-open', !isOpen);
  document.body.classList.toggle('menu-open', !isOpen);
});
  });


  // ===========================================
  // Product Card Hover Effects
  // ===========================================
  
  class ProductCards {
    constructor() {
      this.cards = document.querySelectorAll('.product-card');
      
      if (this.cards.length) {
        this.init();
      }
    }
    
    init() {
      this.cards.forEach(card => {
        // Add to cart quick action
        const addBtn = card.querySelector('[data-quick-add]');
        if (addBtn) {
          addBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.quickAdd(addBtn);
          });
        }
      });
    }
    
    async quickAdd(btn) {
      const productId = btn.dataset.productId;
      const variantId = btn.dataset.variantId;
      
      btn.classList.add('loading');
      
      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });
        
        if (response.ok) {
          btn.classList.remove('loading');
          btn.classList.add('success');
          
          // Update cart count
          this.updateCartCount();
          
          setTimeout(() => {
            btn.classList.remove('success');
          }, 2000);
        }
      } catch (error) {
        console.error('Error adding to cart:', error);
        btn.classList.remove('loading');
      }
    }
    
    async updateCartCount() {
      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();
        
        const countEl = document.querySelector('.cart-count');
        if (countEl) {
          countEl.textContent = cart.item_count;
          countEl.classList.add('bump');
          setTimeout(() => countEl.classList.remove('bump'), 300);
        }
      } catch (error) {
        console.error('Error updating cart count:', error);
      }
    }
  }

  // ===========================================
  // Quantity Selector
  // ===========================================
  
  class QuantitySelector {
    constructor() {
      this.selectors = document.querySelectorAll('.quantity-selector');
      
      if (this.selectors.length) {
        this.init();
      }
    }
    
    init() {
      this.selectors.forEach(selector => {
        const minusBtn = selector.querySelector('[data-qty-minus]');
        const plusBtn = selector.querySelector('[data-qty-plus]');
        const input = selector.querySelector('.qty-value');
        
        if (minusBtn && plusBtn && input) {
          minusBtn.addEventListener('click', () => {
            const current = parseInt(input.textContent) || 1;
            if (current > 1) {
              input.textContent = current - 1;
              this.triggerChange(selector, current - 1);
            }
          });
          
          plusBtn.addEventListener('click', () => {
            const current = parseInt(input.textContent) || 1;
            input.textContent = current + 1;
            this.triggerChange(selector, current + 1);
          });
        }
      });
    }
    
    triggerChange(selector, value) {
      const event = new CustomEvent('quantity-change', {
        detail: { quantity: value }
      });
      selector.dispatchEvent(event);
    }
  }

  // ===========================================
  // Newsletter Form
  // ===========================================
  
  class NewsletterForm {
    constructor() {
      this.forms = document.querySelectorAll('.newsletter-form');
      
      if (this.forms.length) {
        this.init();
      }
    }
    
    init() {
      this.forms.forEach(form => {
        form.addEventListener('submit', (e) => {
          // Let Shopify handle the submission
          // Add visual feedback
          const btn = form.querySelector('button[type="submit"]');
          if (btn) {
            btn.textContent = 'Subscribing...';
          }
        });
      });
    }
  }

  // ===========================================
  // Sparkle Effects
  // ===========================================
  
  class SparkleEffects {
    constructor() {
      this.container = document.querySelector('.hero');
      
      if (this.container) {
        this.createSparkles();
      }
    }
    
    createSparkles() {
      const sparkleCount = 8;
      
      for (let i = 0; i < sparkleCount; i++) {
        const sparkle = document.createElement('div');
        sparkle.className = 'sparkle';
        sparkle.style.cssText = `
          top: ${Math.random() * 100}%;
          left: ${Math.random() * 100}%;
          animation-delay: ${Math.random() * 3}s;
        `;
        this.container.appendChild(sparkle);
      }
    }
  }

  // ===========================================
  // Initialize Everything
  // ===========================================
  
  document.addEventListener('DOMContentLoaded', () => {
    new VideoModal();
    new ScrollReveal();
    new StickyHeader();
    new ProductCards();
    new QuantitySelector();
    new NewsletterForm();
    new SparkleEffects();
  });

})();
